import React, { type FC, useContext } from 'react';

import { StepContext } from '../../contexts/stepContext';
import { UserContext } from '../../contexts/userContext';
import { SubmitFooterContent } from '../SubmitFooterContent';

export const ModalFooter: FC = (): JSX.Element => {
  const { activeStep } = useContext(StepContext);
  const { userData: { disabled, checked } } = useContext(UserContext);

  return (
    <SubmitFooterContent activeStep={activeStep}
                         disabled={disabled}
                         checked={checked} />
  );
};
